import Button from "./Buttons/Button"

const Banner = ({title, call, link}) => {
    return (
        <div className="bg-bk py-8 lg:py-12 h-max">
            <div className='flex-col w-max items-center mx-auto'>
                <p className='text-3xl lg:text-4xl xl:text-5xl text-white text-center'>{title}</p>
                <div className="w-max mx-auto mt-10">
                    <Button call={call} link={link}/>
                </div>
            </div>
        </div>
    )
}

export default Banner